import { c as _c } from "react/compiler-runtime";
import type { Entity } from '@onefootprint/request-types/dashboard';
import type useEntityVault from '@/entities/hooks/use-entity-vault';
import type { EntityVault } from '@/types/vault';
import Subsection from '../subsection';
import Fieldset from './components/fieldset';
import useFieldsets from './hooks/use-fieldsets';
type OnboardingVaultDataProps = {
  entity: Entity;
  vault: ReturnType<typeof useEntityVault>;
};
const OnboardingVaultData = t0 => {
  const $ = _c(5);
  const {
    entity,
    vault
  } = t0;
  const {
    data: vaultData
  } = vault;
  const fieldsets = useFieldsets(entity, vaultData?.vault as EntityVault);
  let t1;
  if ($[0] !== fieldsets) {
    t1 = Object.entries(fieldsets);
    $[0] = fieldsets;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== vaultData) {
    t2 = <Subsection><div className="grid grid-cols-1 gap-x-10 gap-y-5 md:grid-cols-2">{t1.map(t3 => {
          const [key, fieldset] = t3;
          return <Fieldset key={key} fields={fieldset.fields} title={fieldset.title} vaultData={vaultData} />;
        })}</div></Subsection>;
    $[2] = t1;
    $[3] = vaultData;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default OnboardingVaultData;